import { render, staticRenderFns } from "./SuspensionNew.vue?vue&type=template&id=53c3022a&scoped=true&"
import script from "./SuspensionNew.vue?vue&type=script&lang=js&"
export * from "./SuspensionNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c3022a",
  null
  
)

export default component.exports